<template>
  <div class="bigbox">
    <div class="top">
      <span>学生姓名：{{ userform.realName }}</span>
      <span>联系电话：{{ userform.contactPhone }}</span>
      <span>性别：{{ userform.sex === 0 ? "男" : "女" }}</span>
      <span v-if="userform.disciplineType === 1">科别：理科</span>
      <span v-if="userform.disciplineType === 2">科别：文科</span>
      <span v-if="
        userform.disciplineType === 0 ||
        userform.disciplineType === 3 ||
        userform.disciplineType === 4
      ">科目：<span v-if="userform.discipline.indexOf('物理') !== -1">物理 </span><span
          v-if="userform.discipline.indexOf('历史') !== -1">历史 </span>
        <span v-if="userform.discipline.indexOf('化学') !== -1">化学 </span><span
          v-if="userform.discipline.indexOf('生物') !== -1">生物 </span>
        <span v-if="userform.discipline.indexOf('政治') !== -1">政治 </span><span
          v-if="userform.discipline.indexOf('地理') !== -1">地理 </span>
      </span>
      <span>所在中学：{{ userform.schoolName }}</span>
      <span>毕业年份：{{ userform.graduateYear }}</span>
      <span>高考成绩：{{ userform.adminScore ? userform.adminScore : 0 }}</span>
      <span>等位分：{{ equalScore ? equalScore : 0 }}</span>
      <span>位次：{{
          userform.scores
            ? userform.scores.accumulate
              ? userform.scores.accumulate
              : 0
            : 0
      }}</span>
    </div>
    <el-tabs tab-position="top" v-model="activeName">
      <el-tab-pane label="测评结果" name="first">
        <evaluationResults :userform="userform" v-if="activeName === 'first'" />
      </el-tab-pane>
      <el-tab-pane label="咨询记录" name="second">
        <keep-alive>
          <consultationRecords v-if="activeName === 'second'" :userform="this.userform" :oneId="this.oneId"
            :orderId="this.orderId" />
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="志愿草稿" name="third">
        <volunteerDraft :id="id" :oneId="oneId" :userform="userform" v-if="activeName === 'third'" ref="third"
          @goscore="goscore" />
      </el-tab-pane>
      <!-- volunteerPreliminary -->
      <el-tab-pane label="志愿预案" name="eight">
        <volunteerPreliminary :id="id" :oneId="oneId" :userform="userform" v-if="activeName === 'eight'" ref="eight"
          @goscore="goscore" />
      </el-tab-pane>
      <el-tab-pane label="志愿方案" name="five">
        <voluntaryScheme :userform="userform" :oneId="oneId" v-if="activeName === 'five'" />
      </el-tab-pane>
      <el-tab-pane label="客户信息" name="six">
        <customerInformation :userform="userform" v-if="activeName === 'six'" :sixactiveName="sixactiveName" @scoreChange="scoreChange" />
      </el-tab-pane>
      <el-tab-pane label="订单信息" name="seven">
        <orderInformation :orderId="orderId" v-if="activeName === 'seven'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getStudentDetail, selectEqualScore } from "@/api/serviceManagement.js";
import evaluationResults from "./components/evaluationResults";
import orderInformation from "./components/orderInformation";
import customerInformation from "./components/customerInformation";
import volunteerDraft from "./components/volunteerDraft";
import volunteerPreliminary from "./preliminay/volunteerPreliminary";
import consultationRecords from "./components/consultationRecords";
import voluntaryScheme from "./components/voluntaryScheme";
export default {
  components: {
    evaluationResults,
    orderInformation,
    customerInformation,
    volunteerDraft,
    volunteerPreliminary,
    consultationRecords,
    voluntaryScheme,
  },
  data() {
    return {
      id: "",
      activeName: "first",
      userform: {},
      oneId: "",
      orderId: "",
      userId: "",
      sixactiveName: "first",
      equalScore: 0
    };
  },
  watch: {
    $route(val) {
      if (val.path === "/studentDetails") {
        this.activeName = this.$route.query.activeName || "first";
        this.id = this.$route.query.id;
        this.oneId = this.$route.query.oneId;
        this.orderId = this.$route.query.orderId;
        if (this.id) {
          this.getStudentDetail(this.id, false);
        }
        if (this.activeName === "third") {
          this.$refs.third.getDraftList();
        }
      }
    },
  },
  created() {
    if (this.activeName === "third") {
      this.$refs.third.getDraftList();
    }
  },
  mounted() {
    this.activeName = this.$route.query.activeName || "first";
    this.id = this.$route.query.id;
    this.oneId = this.$route.query.oneId;
    this.orderId = this.$route.query.orderId;
    if (this.id) {
      this.getStudentDetail(this.id, false);
    }

  },
  methods: {
    // changeactive() {
    //   this.activeName = "five";
    // },
    goscore() {
      this.sixactiveName = "second"
      this.activeName = "six";
    },
    scoreChange(studentId, isSaveScore){
        this.getStudentDetail(studentId, isSaveScore)
    },
    //获取学生详情
    getStudentDetail(id, isSaveScore) {
      getStudentDetail({ studentId: id }).then((res) => {
        if (res.code === 1) {
          this.userform = res.data || {};
          let form = {
            disciplineType: this.userform.disciplineType,
            provinceId: this.userform.province,
            score: this.userform.adminScore || 0,
            year: this.userform.graduateYear,
          };
          if (!this.userform.scores) {
            this.userform.scores = { accumulate: null };
          }
          if (this.userform.scores) {
            form.accumulate = this.userform.scores.accumulate;
          }
          selectEqualScore(form).then((res) => {
            if (res.code === 1) {
              this.userform.examscore = res.data || 0;
              this.equalScore = res.data || 0
            }
          });
        }
        if (isSaveScore && isSaveScore === true){
          this.sixactiveName = 'second'
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.bigbox {
  padding: 20px;

  .top {
    padding: 0px 10px 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    font-size: 14px;
    margin-bottom: 10px;

    span {
      margin-right: 10px;
      display: inline-block;
    }
  }
}
</style>
